import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import LoadingSpinner from './LoadingSpinner'
import { ROLES } from '../services/permissionService'

export default function ProtectedRoute({ children, redirectReplenishOnly = false }) {
  const {
    currentUser,
    userClaims,
    userPermissions,
    permissionsLoading,
    permissionsReady,
    permissionsError,
    refreshPermissions,
  } = useAuth()
  const location = useLocation()

  if (!currentUser) {
    // Save the current path so we can redirect back after login
    return <Navigate to="/login" state={{ returnUrl: location.pathname }} replace />
  }

  if (!userClaims || permissionsLoading || !permissionsReady) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <LoadingSpinner />
      </div>
    )
  }

  if (!userClaims.sadmin && !userPermissions) {
    return (
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-4">
        <div className="card border-0 shadow-sm text-center" style={{ maxWidth: '460px' }}>
          <div className="card-body p-4">
            <i className="fas fa-user-shield text-warning fa-3x mb-3"></i>
            <h1 className="h4">Your access could not be loaded</h1>
            <p className="text-muted mb-4">
              {permissionsError || 'Please check your connection and try again.'}
            </p>
            <button type="button" className="btn btn-primary" onClick={refreshPermissions}>
              <i className="fas fa-sync-alt me-2"></i>
              Try Again
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (redirectReplenishOnly) {
    const roles = userPermissions?.roles || []
    const isReplenishOnly = roles.length === 1 && roles.includes(ROLES.REPLENISH_WORKER)
    if (isReplenishOnly) {
      return <Navigate to="/replenish-worker" replace />
    }
  }

  return children
}
